/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from './pagecontent_styles';



/* ========== ~~~~~~~~~~ PAGE CONTENT ~~~~~~~~~~ ========== */
const PageContent = injectSheet(styles)((props) => {
	return (
		<div className={`${props.classes.pagecontent} pagecontent`}>
            {props.children}
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PageContent;
